import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-lot-add-photo-uploading-list-item-error',
  templateUrl: './lot-add-photo-uploading-list-item-error.component.html',
  styleUrls: ['./lot-add-photo-uploading-list-item-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotAddPhotoUploadingListItemErrorComponent {
  @Input() error: Error;

  get message(): string {
    return this.error?.message || 'Unknown error';
  }
}
